import { Typography } from '@mui/material';
import { FilePreviewList, UploadImagesComponent } from 'src/hooks/useForm';
import Images from '../ImageCarousel';
import { useForm } from './Context';
import * as backend from 'src/backend';
import { BUCKET_NAME, S3_BASE_URL } from 'src/config';

export async function uploadImages({ images, folder, source = null }) {
  return await Promise.all(
    images.map(async (image) => {
      if (typeof image === 'string') return image;

      const { url, file, data } = image;

      if (url) return url;

      return await backend.image.upload(
        file,
        data,
        {
          folder,
          filetype: file.type,
        },
        folder,
        source
      );
    })
  );
}

export async function uploadImagesAndReturnURLWithName({
  images,
  folder,
  source = null,
}) {
  let result = [];
  for (let img of images) {
    if (typeof img === 'string') {
      result.push({ url: img });
      continue;
    }

    const { url, file, data } = img;
    if (url) {
      result.push(img);
    } else {
      const uploadedUrl = await uploadImages({
        images: [{ file, data }],
        folder,
        source,
      });
      result.push({ url: uploadedUrl[0], name: file?.name });
    }
  }
  return result;
}

export default function UploadImages({
  id,
  label,
  defaultValue,
  maxFiles,
  handleFileCountExceed,
  documentLayout,
  fileListText,
  includeLink,
  ...props
}) {
  const { readonly, error, value, handleChange } = useForm(id, defaultValue);

  if (readonly) {
    if (!Array.isArray(value) || value.length === 0) {
      return null;
    }
    const files = value.map((url) => `${S3_BASE_URL}/${BUCKET_NAME}/${url}`);
    if (documentLayout) {
      return (
        <FilePreviewList
          text={fileListText}
          files={files}
          includeLink={includeLink}
        />
      );
    }
    return (
      <Images
        width="100%"
        height="300px"
        images={files}
        objectFit="contain"
        downloadName={label}
      />
    );
  }

  return (
    <>
      <Typography variant="h5" sx={{ mb: 1 }}>
        {label}
      </Typography>

      <UploadImagesComponent
        label={label}
        value={value ?? []}
        onChange={(newValue) => handleChange({ target: { value: newValue } })}
        error={error}
        objectFit="contain"
        maxFiles={maxFiles}
        handleFileCountExceed={handleFileCountExceed}
        documentLayout={documentLayout}
        fileListText={fileListText}
        {...props}
      />
    </>
  );
}
